export default __webpack_public_path__ + "static/media/caribeno-intro-poster.c1dde98e.png";